module.exports = __webpack_public_path__ + "img/alipay.15ba5f48.svg";